import { render, staticRenderFns } from "./footerCustom.vue?vue&type=template&id=0256141e&scoped=true&"
import script from "./footerCustom.vue?vue&type=script&lang=js&"
export * from "./footerCustom.vue?vue&type=script&lang=js&"
import style0 from "./footerCustom.vue?vue&type=style&index=0&id=0256141e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0256141e",
  null
  
)

export default component.exports